module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form id=\"user_edit_password\"> <div class=\"form-group\"> <label>Current Password</label> <input type=\"password\" placeholder=\"Required to change password\" class=\"form-control\" id=\"user_current_password\"> </div> <div class=\"form-group\"> <label>Password <small class=\"text-muted\">(Case-sensitive. Minimum of 8 characters)</small></label> <input type=\"password\" placeholder=\"Password\" class=\"form-control\" id=\"user_password\"> </div> <div class=\"form-group\"> <label>Password Confirmation</label> <input type=\"password\" placeholder=\"Confirm Password\" class=\"form-control\" id=\"user_password_confirmation\"> </div> <button type=\"submit\" class=\"btn btn-red pull-right\">Update Password</button> <div class=\"clearfix\"></div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_edit_password.ejs
// module id = 878
// module chunks = 1